"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pagination_1 = require("./Pagination");
exports.default = Pagination_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Pagination/index.js
// module id = 1206
// module chunks = 8